import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpContextToken, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';

export const BYPASS_JW_TOKEN = new HttpContextToken(() => false);

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private storageService:StorageService,
    private router:Router,

  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenMSSP = this.storageService.getData("tokenMSSP")

    let request = req
    if(tokenMSSP){
      request = req.clone({
        setHeaders: {
          tokenmssp: tokenMSSP
        }
      })
    }
    if (req.context.get(BYPASS_JW_TOKEN) === true) {
      return next.handle(req)
    }
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
          } else {
            switch (error.status) {
              case 500:
                const tokenURL = this.storageService.getData('encodedToken');
                this.router.navigate(['/'], { queryParams: { q: tokenURL } })
                alert('Ocurrió un error, favor de volver a intentarlo mas tarde')
                break;
            }
          }
        }
        throw 'error en el servidor interceptor'
      })
    )
  }
}
